var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-link btn-blank text-left break-link vulnerability-name-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.handleIssueClick()}}},[_vm._v("\n  "+_vm._s(_vm.issue.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }